
import React, { useEffect, lazy, Suspense } from 'react';
import Navigation from './Navigation';
import { Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}



const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Reveal animation on scroll
  useEffect(() => {
    // Otimização: usar IntersectionObserver em vez de eventos de scroll
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          // Otimização: parar de observar elementos que já foram revelados
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.1
    });
    
    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach(el => {
      observer.observe(el);
    });
    

    
    // Adicionar link de preload para a imagem LCP
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = '/lovable-uploads/6df25097-8673-47ce-94a1-5910bd758cca.png';
    document.head.appendChild(preloadLink);
    
    return () => {
      // Limpar observer
      revealElements.forEach(el => {
        observer.unobserve(el);
      });
      
      // Remover o preload link
      if (preloadLink.parentNode) {
        preloadLink.parentNode.removeChild(preloadLink);
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <footer className="bg-primary-dark py-8 text-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8">
            <p className="mb-4 md:mb-0">© {new Date().getFullYear()} Método PPS. Todos os direitos reservados.</p>
            <div className="flex space-x-8">
              <a 
                href="https://www.instagram.com/rosane_baldissera/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-primary-light transition-colors"
              >
                <Instagram className="h-5 w-5" />
                <span>Instagram</span>
              </a>
              <a 
                href="https://www.youtube.com/@RosaneBaldissera" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-primary-light transition-colors"
              >
                <Youtube className="h-5 w-5" />
                <span>YouTube</span>
              </a>
            </div>
          </div>
          <div className="flex justify-center md:justify-start space-x-6">
            <Link to="/termos-e-politicas#termos" className="hover:text-primary-light transition-colors">Termos de Uso</Link>
            <Link to="/termos-e-politicas#privacidade" className="hover:text-primary-light transition-colors">Política de Privacidade</Link>
            <a href="mailto:contato@metodopps.com.br" className="hover:text-primary-light transition-colors">Contato</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
